var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeartFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.heart-st0{fill:#808080;fill-opacity:0;}\r\n\t.heart-st1{fill:#808080;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "heart-st0",
    width: 36,
    height: 36
  }), /*#__PURE__*/React.createElement("path", {
    className: "heart-st1",
    d: "M23.7,6L23.7,6c-2.3,0-4.4,1.1-5.7,2.9C16.6,7.1,14.5,6,12.3,6l0,0c-1.9,0-3.8,0.8-5.1,2.3 c-1.4,1.5-2.1,3.6-2,5.7c0.3,4,3.4,6.7,6.7,9.6c2,1.8,4.1,3.6,5.6,5.8L18,30l0.6-0.8c1.6-2.2,3.7-4,5.6-5.8 c3.3-2.9,6.4-5.6,6.7-9.6c0.1-2.1-0.6-4.1-2-5.7C27.6,6.8,25.7,6,23.7,6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartFill);
export default __webpack_public_path__ + "static/media/heart-fill.7467d84065d55362d70b73e6ee0064c3.svg";
export { ForwardRef as ReactComponent };